export default "__VITE_ASSET__BFTqNpOW__"